export const LOADER_TRANSITION_IN_DURATION_MILLIS = 500;
export const LOADER_TRANSITION_IN_DEFAULT_DELAY_MILLIS = 250;
